import { api } from '@gik/core/api';

interface IPageInformation {
  description: string;
  specialNotes: string;
  title: string;
}

export function updatePageInformation(routeId: string, data: IPageInformation) {
  return api.put(`inkinds/${routeId}/page-information`, {
    json: data,
  });
}

export function updatePagePhoto(routeId: string, base64Photo: string) {
  return api.post(`inkinds/${routeId}/photo`, {
    body: base64Photo,
  });
}
